/*
  Xeridas inquiry — opens the "Trabaja con nosotros" dialog (snippets/xeridas-inquiry.liquid).
  - Links with #trabaja-con-nosotros open it with every option;
    #trabaja-con-nosotros-<key> preselects that option (its data-key) and
    shows its kicker / title. Works from any page, whatever the link's path.
  - The same hash in the address bar opens it on load; so does the form's
    own anchor (#XeridasInquiryForm) after Shopify posts it back.
  - Native <dialog>: focus stays inside, Escape closes, focus returns to the
    link. The page behind is locked with Dawn's body.overflow-hidden, which
    also pauses Lenis (xeridas-motion.js). A click on the backdrop closes.
    Opening and closing are animated in CSS; closing waits for the sheet's
    animation (.is-closing) before the dialog actually closes.
*/
(function () {
  if (window.__xeridasInquiry) return;
  window.__xeridasInquiry = true;

  const HASH = /^#trabaja-con-nosotros(?:-([a-z0-9-]+))?$/;
  let opener = null;

  const dialog = () => document.querySelector('[data-xeridas-inquiry]');

  function choose(d, key) {
    const select = d.querySelector('[data-inquiry-select]');
    if (!select) return;
    if (key !== undefined) {
      const match = [...select.options].find((option) => option.dataset.key === key);
      select.value = match ? match.value : '';
    }
    const option = select.selectedOptions[0] || select.options[0];
    const kicker = d.querySelector('[data-inquiry-kicker]');
    const title = d.querySelector('[data-inquiry-title]');
    if (kicker && option?.dataset.kicker) kicker.textContent = option.dataset.kicker;
    if (title && option?.dataset.title) title.textContent = option.dataset.title;
  }

  function open(key, trigger) {
    const d = dialog();
    if (!d || typeof d.showModal !== 'function') return false;
    opener = trigger || document.activeElement;
    // A posted form keeps its state (and choice); a new opening sets the option.
    if (!d.querySelector('[data-inquiry-status]')) choose(d, key || '');
    if (!d.open) d.showModal();
    document.body.classList.add('overflow-hidden');

    const status = d.querySelector('[data-inquiry-status]');
    const select = d.querySelector('[data-inquiry-select]');
    const first = status || (select && !select.value ? select : d.querySelector('input:not([type="hidden"])'));
    first?.focus({ preventScroll: true });
    return true;
  }

  // Plays the closing animation (component-xeridas-inquiry.css), then closes.
  function requestClose(d) {
    if (!d.open || d.classList.contains('is-closing')) return;
    const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (still || typeof d.getAnimations !== 'function') {
      d.close();
      return;
    }
    d.classList.add('is-closing');
    const sheet = d.getAnimations().filter((animation) => animation.effect?.target === d);
    const done = () => {
      if (!d.classList.contains('is-closing')) return;
      d.classList.remove('is-closing');
      d.close();
    };
    Promise.all(sheet.map((animation) => animation.finished.catch(() => {}))).then(done);
    setTimeout(done, 500); // never left half-closed (e.g. a background tab)
  }

  function onClose() {
    document.body.classList.remove('overflow-hidden');
    if (HASH.test(window.location.hash) || window.location.hash === '#XeridasInquiryForm') {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
    if (opener && typeof opener.focus === 'function') opener.focus({ preventScroll: true });
    opener = null;
  }

  function init() {
    const d = dialog();
    if (!d || d.dataset.ready) return;
    d.dataset.ready = 'true';

    d.addEventListener('close', onClose);
    // Escape: animate out instead of the instant native close.
    d.addEventListener('cancel', (event) => {
      event.preventDefault();
      requestClose(d);
    });
    d.querySelector('[data-inquiry-close]')?.addEventListener('click', () => requestClose(d));
    // The panel fills the dialog box, so a click on the dialog itself is the backdrop.
    d.addEventListener('click', (event) => {
      if (event.target === d) requestClose(d);
    });
    d.querySelector('[data-inquiry-select]')?.addEventListener('change', () => choose(d));

    const hash = window.location.hash;
    const match = hash.match(HASH);
    if (match) open(match[1]);
    else if (hash === '#XeridasInquiryForm' && d.querySelector('[data-inquiry-status]')) open();
  }

  // Capture phase: runs before the smooth-scroll anchor handler.
  document.addEventListener(
    'click',
    (event) => {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest && event.target.closest('a[href*="#trabaja-con-nosotros"]');
      if (!link) return;
      const match = new URL(link.href, window.location.href).hash.match(HASH);
      if (match && open(match[1], link)) event.preventDefault();
    },
    true
  );

  window.addEventListener('hashchange', () => {
    const match = window.location.hash.match(HASH);
    if (match) open(match[1]);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
